import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Header from "../../../../containers/Header";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import Footer from "../../../../containers/Footer";
import FirstDepositBonus from "../../../../assets/images/banner/first-deposit-bonus.jpg";
import SecondDepositBonus from "../../../../assets/images/banner/second-deposit-bonus.jpg";
import ThirdDepositBonus from "../../../../assets/images/banner/third-deposit-bonus.jpg";
import ReferralBonus from "../../../../assets/images/banner/referral-bonus.jpg";
import FirstDeposit from "../../../../assets/images/banner/first-deposit.png";
import SecondDeposit from "../../../../assets/images/banner/second-deposit.png";
import ThirdDeposit from "../../../../assets/images/banner/third-deposit.png";
import Referral from "../../../../assets/images/banner/referral.png";

export const promotionsData = [
  {
    id: 1,
    keyUrl: "first-deposit-bonus",
    title: "First Deposit Bonus",
    subTitle: "Get up to 300% bonus",
    image: FirstDepositBonus,
    image_2: FirstDeposit,
    href: "/gatewaylist",
    content:
      "Get up to 300% bonus on your first deposit as a Betheroz member. From Deposit of RS 300-5000, Bonus will be 300% From Deposit of RS 5001- 10000, Bonus will be 200% From Deposit of RS 10001- 500000, Bonus will be 100%. NOTE:- A 30x turnover of the bonus amount must be completed to activate the bonus. NOTE Maximum Bonus you can achieve is 50000.",
  },
  {
    id: 2,
    keyUrl: "second-deposit-bonus",
    title: "Second Deposit Bonus",
    subTitle: "Now get a 50% bonus",
    image: SecondDepositBonus,
    image_2: SecondDeposit,
    href: "/gatewaylist",
    content:
      "Second time lucky, only on Betheroz! Now get a 50% bonus on your second deposit as a Betheroz member. Note: Eg: If the user deposits Rs. 1000, he will receive a bonus worth Rs.500. The bonus will be split into (10 or 100) equal parts and can be activated as he completes the turnover. The required turnover for the second deposit bonus is 15x which will also be split accordingly. NOTE : Maximum bonus you can achieve is 50000.",
  },
  {
    id: 3,
    keyUrl: "third-deposit-bonus",
    title: "Third Deposit Bonus",
    subTitle: "Now get a 25% bonus",
    image: ThirdDepositBonus,
    image_2: ThirdDeposit,
    href: "/gatewaylist",
    content:
      "Third time lucky, only on Betheroz! Now get a 25% bonus on your third deposit as a Betheroz member. Note: Eg: If the user deposits Rs. 1000, he will receive a bonus worth Rs.250. The bonus will be split into (10 or 100) equal parts and can be activated as he completes the turnover. The required turnover for the third deposit bonus is 10x which will also be split accordingly. NOTE: Maximum bonus you can achieve is 50000.",
  },
  {
    id: 4,
    keyUrl: "referral-bonus",
    title: "Referral Bonus",
    subTitle: "Get a 15% bonus",
    image: ReferralBonus,
    image_2: Referral,
    href: "/referral",
    content:
      "Share your personal referral code with your friend and get a 15% bonus of every single deposit they make thereafter! Note: A.To redeem the bonus amount, the user must complete a turnover of 35x on SPORTSBOOK & CASINO. B. Bonus will be credited after completing the rollover NOTE:-Maximum Bonus you can receive for Referral Bonus is 50000.",
  },
];

const Promotion = () => {
  const navigate = useNavigate();
  const { isAuth } = useSelector((state) => state.auth);

  return (
    <>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      <main className="main">
        <div className="promotions-card-list">
          <div class="pagesHeading">
            <h2 class="sectionTitle">Promotion</h2>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>

          <div className="promotiion-content mt-4 mb-5">
            <div className="inner-wrapper">
              {promotionsData.map((promo) => (
                <div
                  key={promo.id}
                  className="promotion"
                  onClick={() => navigate(promo?.keyUrl)}
                >
                  <img src={promo.image} alt={promo.title} />
                  <h6 className="title">{promo.title}</h6>
                  <p className="content">{promo.subTitle}</p>
                  <button className="see-more-btn">See More</button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      {isAuth ? <Footer /> : <BeforeLoginFooter />}
    </>
  );
};

export default Promotion;
